import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccountRoutingModule } from "@src/app/pages/profile/account/account-routing.module";

@Component({
  selector: 'app-mini-env-info-card',
  imports: [CommonModule, AccountRoutingModule],
  templateUrl: './mini-env-info-card.component.html',
  styleUrl: './mini-env-info-card.component.scss'
})
export class MiniEnvInfoCardComponent {

  @Input() title: string = '';
  @Input() description: string | number = '';
  @Input() icon1: string = '';
  @Input() icon2: string = '';
  @Input() icon3: string = '';
  @Input() backgroundColor: string = '#f5f5f5';
  @Input() isFree = false;
  @Input() link = '';
  @Input() planes : string = '';
  @Input() enableRouter = true;
}
